<footer class="footer">
  <p class="copyright pull-right">
    &copy; {{date | date: 'yyyy'}} <a href="https://www.frankli.io">Frankli</a>. Connect | Align | Grow.
  </p>
</footer>